<template>
  <b-container id="BookSuite" class="outer-container">
    <div id="ready-to-book-blurb">
      <h2>Ready To Book A Suite?</h2>
      <div class="line"></div>
      <p>
        For more information, or to rent or buy a suite, fill out the form or
        call <span class="bold-text">972-RANGERS (x3).</span>
      </p>
    </div>
    <div v-if="submitStatus !== 'OK'" id="suite-form">
      <iframe :src="iframeSrc" frameborder="0"></iframe>
    </div>
    <div v-if="submitStatus === 'OK'" id="success-form">
      <div id="success-text">
        <img src="@/assets/icons/icon_checkmark-success.svg" alt="Checkmark" />
        <h2>SUCCESS!</h2>
        <p>
          Your request has been sent to a client services executive. They will
          be in touch soon!
        </p>
      </div>
    </div>
  </b-container>
</template>

<script>
import {
  required,
  minLength,
  email,
  alpha,
  numeric,
} from "vuelidate/lib/validators";
//import VueRecaptcha from "vue-recaptcha";
export default {
  name: "BookSuiteForm",
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      interest: "",
      submitStatus: null,
      // iframeSrc:
      //   "https://rangers.fanportal-mlb.com/2022suites/app/v4/form.html",
      iframeSrc: "form.html",
    };
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        console.log(this.submitStatus);
      } else {
        //setInterval(this.timestamp(), 500);
        this.submitStatus = "OK";
      }
    },
    timestamp() {
      var response = document.getElementById("g-recaptcha-response");
      if (response == null || response.value.trim() == "") {
        var elems = JSON.parse(
          document.getElementsByName("captcha_settings")[0].value
        );
        elems["ts"] = JSON.stringify(new Date().getTime());
        document.getElementsByName("captcha_settings")[0].value =
          JSON.stringify(elems);
      }
    },
  },
  validations: {
    firstName: {
      required,
      alpha,
    },
    lastName: {
      required,
      alpha,
    },
    email: {
      required,
      email,
    },
    phone: {
      required,
      minLength: minLength(10),
      numeric,
    },
    interest: {
      required,
    },
  },
  //components: { VueRecaptcha },
};
</script>

<style lang="scss" scoped>
.outer-container {
  margin: 100px auto 0;
  justify-content: space-between;
  display: flex;
  @media only screen and (max-width: $md) {
    flex-direction: column;
  }
  gap: 20px;
  #ready-to-book-blurb {
    flex-basis: 20%;
    @media only screen and (max-width: $md) {
      margin: 0 0 0 1em;
    }
    h2 {
      font-family: "BertholdCondensed";
      font-weight: 700;
      text-transform: uppercase;
      color: $dark-blue;
      font-size: 40px;
      line-height: 32px;
      width: 127px;
    }
    p {
      font-size: 16px;
      width: 195px;
      margin-top: 1.5em;
      @media only screen and (max-width: $md) {
        width: 85%;
      }
    }
    text-align: left;
  }
  #suite-form {
    width: 100%;
    height: 500px;
    @media only screen and (max-width: $md) {
      height: 575px;
    }
    iframe {
      width: 100%;
      height: 100%;
      @media only screen and (max-width: $md) {
        max-width: 474px;
      }
    }
    .container {
      display: grid;
      grid-template:
        "a a b b"
        "c c d d"
        "e e e e"
        ". f . g";
      @media only screen and (max-width: $md) {
        grid-template:
          "a a"
          "b b"
          "c c"
          "d d"
          "e e"
          "f f"
          "g g";
      }
      grid-gap: 10px;
      #firstName {
        grid-area: a;
        input {
          // background: url("../../../src/assets/icons/BookingForm/icon_form-user.svg")
          //  no-repeat scroll 7px 7px,
          //  $light-grey;
          background-position: 90% 50%;
          padding-right: 15%;
        }
      }
      #lastName {
        grid-area: b;
        input {
          //background: url("../../../src/assets/icons/BookingForm/icon_form-user.svg")
          //    no-repeat scroll 7px 7px,
          // $light-grey;
          background-position: 90% 50%;
          padding-right: 15%;
        }
      }
      #email {
        grid-area: c;
        input {
          //background: url("../../../src/assets/icons/BookingForm/icon_form-mail.svg")
          // no-repeat scroll 7px 7px,
          // $light-grey;
          background-position: 90% 50%;
          padding-right: 15%;
        }
      }
      #phone {
        grid-area: d;
        input {
          //background: url("../../../src/assets/icons/BookingForm/icon_form-phone.svg")
          // no-repeat scroll 7px 7px,
          //  $light-grey;
          background-position: 90% 50%;
          padding-right: 15%;
        }
      }
      #interest {
        grid-area: e;
        select {
          -webkit-appearance: none;
          -moz-appearance: none;
          background: transparent;
          background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>"),
            linear-gradient(
              180deg,
              rgba(255, 255, 255, 1),
              rgba(232, 232, 232, 1)
            );
          background-repeat: no-repeat;
          background-position: 95% 50%;
          border: 1px solid #000;
          border-radius: 2px;
          padding: 1rem;
          padding-right: 2rem;
        }
      }
      #captcha {
        grid-area: f;
      }
      #submit {
        grid-area: g;
      }
      .form-group {
        .form__input {
          border: 1px solid #000;
          color: #000;
          background-color: $light-grey;
          padding: 0.625rem 0.75rem;
          width: 100%;
          height: calc(2.75rem + 2px);
          transition: border 0.5s ease;
        }
        .form__label {
          font-weight: 600;
          font-size: 13px;
          width: 100%;
          text-align: left;
          text-transform: uppercase;
          transition: color 0.5s ease;
        }
        .interest-select {
          width: 100%;
          height: 50px;
          font-weight: 600;
          font-size: 13px;
        }
      }
      .form-group--error {
        animation-name: shakeError;
        animation-fill-mode: forwards;
        animation-duration: 0.6s;
        animation-timing-function: ease-in-out;
        .form__label {
          color: #fb6340;
        }
        .form__input {
          border-color: #fb6340;
        }
      }
      .error {
        color: #fb6340;
        font-size: 0.75rem;
        line-height: 1;
        margin-top: -0.5rem;
      }
      .submitButton {
        border-radius: 5px;
        border: none;
        color: #fff;
        background-color: $rangers-red;
        font-weight: 700;
        text-transform: uppercase;
        padding: 10px 30px;
      }
    }
  }
  #success-form {
    background-color: $light-grey;
    border-radius: 10px;
    max-width: 600px;
    display: flex;
    align-items: center;
    #success-text {
      margin: 60px 0;
      h2 {
        font-family: "BertholdCondensed";
        font-weight: 700;
        font-size: 40px;
      }
      p {
        padding: 0 160px;
      }
    }
  }

  @keyframes shakeError {
    0% {
      transform: translateX(0);
    }
    15% {
      transform: translateX(0.375rem);
    }
    30% {
      transform: translateX(-0.375rem);
    }
    45% {
      transform: translateX(0.375rem);
    }
    60% {
      transform: translateX(-0.375rem);
    }
    75% {
      transform: translateX(0.375rem);
    }
    90% {
      transform: translateX(-0.375rem);
    }
    100% {
      transform: translateX(0);
    }
  }
}
</style>
